import { render, staticRenderFns } from "./question.component.html?vue&type=template&id=76122697&scoped=true&"
import script from "./question.component.ts?vue&type=script&lang=ts&"
export * from "./question.component.ts?vue&type=script&lang=ts&"
import style0 from "./question.component.scss?vue&type=style&index=0&id=76122697&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76122697",
  null
  
)

export default component.exports